export default "/images/ed6c6d64da1a9f047148e672f8b6a76c.avif";